import React, { Component } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const BASE = '/idea-bet.live/theme/ufa7/';

const LANGS = [
    { code: 'th', name: 'ภาษาไทย' },
    { code: 'en', name: 'English' },
    { code: 'km', name: 'ភាសាខ្មែរ' },
    { code: 'my', name: 'မြန်မာ ' },
    { code: 'id', name: 'bahasa Indo' },
    { code: 'kr', name: '한국어' },
    { code: 'vn', name: 'Tiếng Việt' },
    { code: 'la', name: 'ລາວ' },
    { code: 'cn', name: '简体中文' },
    { code: 'es', name: 'Español' },
    { code: 'ru', name: 'Russian' },
    { code: 'fr', name: 'Français' },
    { code: 'pt', name: 'Português' },
];

const COUNTRIES = [
    { flag: 'kh', dial: '+855', name: 'Cambodia' },
    { flag: 'id', dial: '+62',  name: 'Indonesia' },
    { flag: 'kr', dial: '+82',  name: 'Korea' },
    { flag: 'la', dial: '+856', name: 'Laos' },
    { flag: 'my', dial: '+60',  name: 'Malaysia' },
    { flag: 'mm', dial: '+95',  name: 'Myanmar' },
    { flag: 'sg', dial: '+65',  name: 'Singapore' },
    { flag: 'th', dial: '+66',  name: 'ประเทศไทย / Thailand' },
    { flag: 'vn', dial: '+84',  name: 'Vietnam' },
];

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            linelink: "",
            logoimg: "",
            activeTab: 'user',   // ใช้แค่ชื่อผู้ใช้
            username: "",
            password: "",
            showpass: false,
            showLang: false,
            showPhoneCode: false,
            phoneCode: '+66',
            phoneFlag: 'th',
        };
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    changepass = (e) => {
        e.preventDefault();
        this.setState(s => ({ showpass: !s.showpass }));
    }

    login = async (e) => {
        e.preventDefault();
        const { username, password } = this.state;
        if (!username || !password) {
            Swal.fire({ title: 'แจ้งเตือน', text: 'กรุณากรอกข้อมูลให้ครบถ้วน', icon: 'warning', confirmButtonText: 'ตกลง' });
            return;
        }
        try {
            const res = await instance.post("/api/v1/userlogin", {
                userid: username,
                password: password,
                System: Systems,
                Function: 'validateLoginForm-signin.js'
            });
            if (res.data.status === 200) {
                localStorage.setItem('auth_token', res.data.token);
                toast.success('เข้าสู่ระบบสำเร็จ กำลังเปลี่ยนเส้นทาง...', { position: "top-right", autoClose: 3000, theme: "colored" });
                setTimeout(() => { window.location.href = '/home'; }, 2000);
            } else {
                Swal.fire({ title: 'ผิดพลาด!', text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง', icon: 'error', confirmButtonText: 'ตกลง' });
            }
        } catch {
            Swal.fire({ title: 'ผิดพลาด!', text: 'ไม่สามารถเชื่อมต่อระบบได้', icon: 'error', confirmButtonText: 'ตกลง' });
        }
    }

    async componentDidMount() {
        // Load CSS เฉพาะหน้า signin จาก ufa7 theme
        [
            `${BASE}assets/1760337585578/entry.B2LNsUBP.css`,
            `${BASE}style.css`,
        ].forEach(href => {
            if (!document.querySelector(`link[href="${href}"]`)) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = href;
                link.setAttribute('data-signin', '1');
                document.head.appendChild(link);
            }
        });

        try {
            const res = await instance.post("/api/v1/mainsetting", { System: Systems });
            if (res.data.status === 200) {
                this.setState({
                    linelink: res.data.message[1].value,
                    logoimg: res.data.tblsetting[0].imglogo,
                });
            }
        } catch (e) { }
    }

    componentWillUnmount() {
        // เอา CSS ออกเมื่อออกจากหน้า signin
        document.querySelectorAll('link[data-signin]').forEach(l => l.remove());
    }

    render() {
        const { activeTab, showpass, showLang, showPhoneCode, phoneCode, phoneFlag, linelink, logoimg } = this.state;

        return (
            <div
                id="login-main"
                className="w-full bg-cover bg-center mx-auto max-w-[438px] overflow-hidden relative"
                style={{ backgroundImage: `url(${BASE}images/login-backdrop.webp)` }}
                onClick={() => this.setState({ showLang: false, showPhoneCode: false })}
            >
                <ToastContainer />

                {/* ===== HEADER (fixed) ===== */}
                <section>
                    <div style={{ height: 72 }}></div>
                    <div className="flex justify-between items-center p-4"
                        style={{ position: 'fixed', top: 0, width: '100%', maxWidth: 438, zIndex: 100 }}>
                        <div></div>
                        <div className="flex flex-row items-center">
                            {/* ปุ่มติดต่อเจ้าหน้าที่ */}
                            <div className="mr-4">
                                <a href={linelink} target="_blank" rel="noopener noreferrer">
                                    <div className="flex justify-around items-center social-media-box cursor-pointer social-media-box-line">
                                        <div className="ml-1 mr-1 p-1">
                                            <img className="icon-img w-[22px] h-[22px]"
                                                src={`${BASE}images/layout/icn-line.svg`} alt="" />
                                        </div>
                                        <div className="text-[#FFF] text-xs font-bold mr-3">ติดต่อเจ้าหน้าที่</div>
                                    </div>
                                </a>
                            </div>
                            {/* ปุ่มเลือกภาษา */}
                            <div onClick={e => { e.stopPropagation(); this.setState(s => ({ showLang: !s.showLang, showPhoneCode: false })); }}>
                                <img className="mx-auto w-[40px] h-[40px] cursor-pointer"
                                    src={`${BASE}images/language/icn-lang-th.svg`} alt="lang" />
                            </div>
                        </div>
                    </div>

                    {/* Language dropdown */}
                    {showLang && (
                        <div className="absolute right-3 top-12 float-right mr-2 my-5 z-10"
                            onClick={e => e.stopPropagation()}>
                            <div className="w-[188px] border border-[#464646] bg-[#202020] rounded-lg max-h-[300px] overflow-y-auto">
                                {LANGS.map(lang => (
                                    <div key={lang.code} className="language-item-wrapper"
                                        onClick={() => { localStorage.setItem('lang', lang.code); this.setState({ showLang: false }); }}>
                                        <div className="language-item">
                                            <div className="language-icon">
                                                <img src={`${BASE}images/language/icn-lang-${lang.code}.svg`} alt={lang.code} />
                                            </div>
                                            <div className="language-title"><span>{lang.name}</span></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </section>

                {/* ===== BODY ===== */}
                <div className="h-[calc(100vh-72px)] overflow-auto pb-[100px]">
                    {/* โลโก้ */}
                    <div className="pt-[35%] md:pt-[20%] 2xl:pt-[10%] mb-10">
                        <img className="mx-auto w-[80%] max-w-[438px]"
                            src={logoimg || `${BASE}images/UFABET-LOGO.webp`} alt="UFABET" />
                    </div>

                    {/* ===== LOGIN FORM ===== */}
                    <div className="relative max-w-[524px] mx-auto">
                        <div className="login-form-container">
                            <div className="login-form">
                                <div className="text-center text-xs text-white pt-1">ยินดีต้อนรับ</div>
                                <div className="w-[70%] h-0.5 bg-[#FBDEB226] bg-opacity-90 mt-4 mx-auto">
                                    <div className="horizontal-line"></div>
                                </div>

                                {/* Tab selector */}
                                <div className="mt-4 flex justify-center gap-x-2">
                                    <div
                                        className="login-option-box-item flex items-center justify-center text-sm capitalize login-option-box-selected"
                                        data-target="user"
                                        style={{ cursor: 'default' }}
                                    >
                                        <div className="mx-3">ชื่อผู้ใช้ / Username</div>
                                    </div>
                                    <div
                                        className="login-option-box-item flex items-center justify-center text-sm capitalize login-option-box"
                                        data-target="phone"
                                        style={{ cursor: 'default', opacity: 0.5 }}
                                    >
                                        <div className="mx-3">หมายเลขโทรศัพท์</div>
                                    </div>
                                </div>

                                {/* ===== PHONE TAB ===== */}
                                {activeTab === 'phone' && (
                                    <div className="flex flex-col items-center mt-5 phone">
                                        {/* Phone input */}
                                        <div className="w-[85%] mb-4">
                                            <div className="flex items-center text-[11px] min-h-[54px] mx-auto rounded-xl bg-[#00000080] bottom-animation">
                                                <div className="ml-4">
                                                    <span className={`fi fi-${phoneFlag} fis mt-[10px] text-[18px] phonecodeimg`} title={phoneFlag}></span>
                                                </div>
                                                <div className="flex w-full relative">
                                                    <div className="top-1 text-[10px] absolute ml-[14px] text-[#ECCA77]">เบอร์โทรศัพท์ / Phone number</div>
                                                    <div className="flex justify-center items-center ml-4 cursor-pointer"
                                                        onClick={e => { e.stopPropagation(); this.setState(s => ({ showPhoneCode: !s.showPhoneCode })); }}>
                                                        <div className="mt-3 w-[32px] bg-lighter text-[#FBDEB2] phonecode">{phoneCode}</div>
                                                        <img className="mt-3 flex self-center w-[8px]"
                                                            src={`${BASE}images/layout/icn-down-small.svg`} alt="" />
                                                    </div>
                                                    <div className="flex input-label relative">
                                                        <input
                                                            id="phone-field"
                                                            name="username"
                                                            type="text"
                                                            pattern="[0-9]*"
                                                            inputMode="numeric"
                                                            className="h-[34px] mt-3 w-full ml-4 text-[14px] text-[#F5F5F5] bg-inherit border-none focus:outline-none"
                                                            placeholder=""
                                                            maxLength={15}
                                                            onChange={this.onChange}
                                                            autoComplete="off"
                                                            ref={(el) => { if (el && !el.dataset.ro) { el.setAttribute('readonly', ''); el.dataset.ro = '1'; } }}
                                                            onFocus={(e) => e.target.removeAttribute('readonly')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Country code picker */}
                                        {showPhoneCode && (
                                            <div className="w-[85%] mb-3 bg-[#202020] border border-[#464646] rounded-lg max-h-[200px] overflow-y-auto"
                                                onClick={e => e.stopPropagation()}>
                                                {COUNTRIES.map(c => (
                                                    <div key={c.flag}
                                                        className="flex flex-row mx-2 my-2 h-[30px] items-center rounded-md text-[#FBDEB2] text-xs cursor-pointer hover:bg-white/10"
                                                        onClick={() => this.setState({ phoneCode: c.dial, phoneFlag: c.flag, showPhoneCode: false })}>
                                                        <div className="w-[20px] ml-2">
                                                            <span className={`fi fi-${c.flag} fis`} style={{ fontSize: 18 }} title={c.flag}></span>
                                                        </div>
                                                        <div className="ml-4">{c.dial} {c.name}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {/* Password */}
                                        <div className="w-[85%] mb-2">
                                            <div className="flex items-center text-[12px] mx-auto rounded-xl bg-[#00000080] bottom-animation relative mt-[-7px]">
                                                <div className="absolute mx-4">
                                                    <img src={`${BASE}images/layout/icn-password.svg`} alt="icn" />
                                                </div>
                                                <div className="input-label w-[85%] ml-6">
                                                    <div className="toggleinputshow pl-6 relative top-2 text-[10px] is-on">รหัสผ่าน / Password</div>
                                                    <input
                                                        id="password-field"
                                                        name="password"
                                                        type={showpass ? "text" : "password"}
                                                        className="w-full ml-6 h-[44px] text-[12px] text-[#F5F5F5] bg-inherit border-none focus:outline-none custom-input"
                                                        placeholder="รหัสผ่าน / Password"
                                                        minLength={1} maxLength={30}
                                                        autoCorrect="off" autoCapitalize="off"
                                                        autoComplete="new-password"
                                                        onChange={this.onChange}
                                                        ref={(el) => { if (el && !el.dataset.ro) { el.setAttribute('readonly', ''); el.dataset.ro = '1'; } }}
                                                        onFocus={(e) => e.target.removeAttribute('readonly')}
                                                    />
                                                </div>
                                                <div className="relative flex flex-end ml-auto mr-4">
                                                    <img className="w-[20px] h-[20px]" style={{ cursor: 'pointer' }}
                                                        src={`${BASE}images/show-password.svg`}
                                                        alt="แสดง/ซ่อนรหัสผ่าน"
                                                        onClick={this.changepass} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* ===== USERNAME TAB ===== */}
                                {activeTab === 'user' && (
                                    <div className="flex flex-col items-center mt-5 user">
                                        {/* Username */}
                                        <div className="w-[85%] mb-4">
                                            <div className="flex items-center text-[12px] mx-auto rounded-xl bg-[#00000080] bottom-animation relative">
                                                <div className="absolute mx-4">
                                                    <img src={`${BASE}images/layout/icn-user.svg`} alt="icn" />
                                                </div>
                                                <div className="input-label w-[85%] ml-6">
                                                    <div className="toggleinputshow pl-6 relative top-2 text-[10px] is-on">ชื่อผู้ใช้ / Username</div>
                                                    <input
                                                        id="username-field"
                                                        name="username"
                                                        type="text"
                                                        className="w-[85%] ml-6 rounded-xl h-[40px] text-[12px] text-[#F5F5F5] bg-inherit border-none focus:outline-none custom-input"
                                                        placeholder="ชื่อผู้ใช้ / Username"
                                                        minLength={1} maxLength={20}
                                                        autoCorrect="off" autoCapitalize="off"
                                                        onChange={this.onChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Password */}
                                        <div className="w-[85%] mb-2">
                                            <div className="flex items-center text-[12px] mx-auto rounded-xl bg-[#00000080] bottom-animation relative mt-[-7px]">
                                                <div className="absolute mx-4">
                                                    <img src={`${BASE}images/layout/icn-password.svg`} alt="icn" />
                                                </div>
                                                <div className="input-label w-[85%] ml-6">
                                                    <div className="toggleinputshow pl-6 relative top-2 text-[10px] is-on">รหัสผ่าน / Password</div>
                                                    <input
                                                        name="password"
                                                        type={showpass ? "text" : "password"}
                                                        className="w-full ml-6 h-[44px] text-[12px] text-[#F5F5F5] bg-inherit border-none focus:outline-none custom-input"
                                                        placeholder="รหัสผ่าน / Password"
                                                        minLength={1} maxLength={30}
                                                        autoCorrect="off" autoCapitalize="off"
                                                        autoComplete="new-password"
                                                        onChange={this.onChange}
                                                        ref={(el) => { if (el && !el.dataset.ro) { el.setAttribute('readonly', ''); el.dataset.ro = '1'; } }}
                                                        onFocus={(e) => e.target.removeAttribute('readonly')}
                                                    />
                                                </div>
                                                <div className="relative flex flex-end ml-auto mr-4">
                                                    <img className="w-[20px] h-[20px]" style={{ cursor: 'pointer' }}
                                                        src={`${BASE}images/show-password.svg`}
                                                        alt="แสดง/ซ่อนรหัสผ่าน"
                                                        onClick={this.changepass} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* ===== SUBMIT ===== */}
                                <div className="mt-2">
                                    <div className="w-full mb-[15px] cursor-pointer">
                                        <div className="flex flex-col relative w-[85%] mx-auto">
                                            <button
                                                onClick={this.login}
                                                className="btn-primary rounded-xl mx-auto w-full h-[40px] flex items-center justify-center p-[0_18px] font-semibold w-[85%] mx-auto cursor-pointer"
                                                style={{
                                                    color: 'black',
                                                    background: 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%)',
                                                    border: '1px solid rgb(236,202,119)',
                                                }}
                                            >
                                                <span className="font-semibold text-[14px]">เข้าสู่ระบบ</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mx-7 text-right my-2">
                                        <a href="/resetPassword" className="text-center text-xs text-[#CDCDCD] cursor-pointer">ลืมรหัสผ่าน? </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ลงทะเบียน */}
                        <div className="flex flex-row justify-center items-center mt-6 mx-4">
                            <div className="text-[#FFF] text-sm">ยังไม่มีบัญชีใช่ไหม?</div>
                            <div className="w-[100px] ml-4">
                                <a href="/register"
                                    className="border border-1 border-[#FDD387] text-[#ECCA77] font-normal text-sm rounded-xl w-full flex items-center justify-center btn-click-animation p-2">
                                    ลงทะเบียน
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
